export function initSignature() {
    // Signature plugin for convert a signature to base64
    if (jQuery('.js-signature').length) {
        const scheduleTourP3 = document.querySelector('#schedule_tour_p3') as HTMLElement;
        const offerDetailRentContract = document.querySelector('#offer-detail-rent-contract-wrap') as HTMLElement;
        const createListingContractPreview = document.querySelector('#create-listing-contract-preview') as HTMLElement;
        
        if (scheduleTourP3) {
            scheduleTourP3.classList.remove('hidden');
            (jQuery('.js-signature') as any).jqSignature();
            scheduleTourP3.classList.add('hidden');
        } else if (offerDetailRentContract) {
            offerDetailRentContract.classList.remove('hidden');
            (jQuery('.js-signature') as any).jqSignature({width: 300});
            offerDetailRentContract.classList.add('hidden');
        } else if (createListingContractPreview) {
            createListingContractPreview.style.display = "block";
            (jQuery('.js-signature') as any).jqSignature();
            createListingContractPreview.style.display = "none";
        }

    }
}